import { type FC, useState } from "react";
import { Link } from "react-router";

import clsx from "clsx";

import { type RoleSlug } from "./segment_copy";

// Slugs are the contract with /demo — expert_pills.tsx maps them onto the
// pills, so a visitor arrives with their answer already selected.
const ROLES: { slug: RoleSlug; name: string; blurb: string }[] = [
  {
    slug: "medical-expert",
    name: "Medical Expert",
    blurb: "Strengthen every report before it leaves your office",
  },
  {
    slug: "legal-expert",
    name: "Legal Expert",
    blurb: "Test any report against the record it cites",
  },
  {
    slug: "insurance-and-risk-expert",
    name: "Insurance & Risk Expert",
    blurb: "Reach determinations you can stand behind",
  },
  {
    slug: "practice-management",
    name: "Practice management",
    blurb: "Keep every case moving and every report consistent",
  },
];

// Markup transcribed from the design port kit (sections/Close.html). Selecting a
// role stamps it onto the CTA (data-role in the kit's behaviour script) so the
// demo request carries which audience asked.
export const Closing: FC = () => {
  const [role, setRole] = useState<string>();

  return (
    <section className="close">
      <div className="wrap">
        <div className="eyebrow2">
          Don’t get stuck doing the basics on your next case
        </div>
        <h2>Ready to become the expert on your case?</h2>
        <p className="sub2">
          Walk through it with people who know med-legal work, on a case like
          yours.
        </p>
        <div className="whichlbl">Which best describes you?</div>
        <div className="roles3">
          {ROLES.map((entry) => (
            <button
              key={entry.slug}
              className={clsx("rolecard", entry.slug === role && "on")}
              type="button"
              aria-pressed={entry.slug === role}
              data-role
              onClick={() => setRole(entry.slug)}
            >
              <div className="rn">{entry.name}</div>
              <div className="rb">{entry.blurb}</div>
            </button>
          ))}
        </div>
        <Link
          className="btn"
          to={role ? `/demo?role=${role}` : "/demo"}
          data-role={role}
        >
          Book a demo
        </Link>
      </div>
    </section>
  );
};
